import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "store/actions";

export const useReduxUser = () => {
  const dispatch = useDispatch();

  // Select user state from Redux store
  const user = useSelector((state) => state.user || {});
  const isAuth = useSelector((state) => state.isAuth || false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const userDomains = useSelector((state) => state.userDomains || []);
  const userSubDomains = useSelector((state) => state.userSubDomains || []);

  // Action dispatchers
  const setUser = useCallback(
    (userData = {}) => {
      dispatch(actions.setUser(userData));
    },
    [dispatch]
  );

  const setAuth = useCallback(
    (authStatus = false) => {
      dispatch(actions.setAuth(authStatus));
    },
    [dispatch]
  );

  const resetUser = useCallback(() => {
    dispatch(actions.resetUser());
  }, [dispatch]);

  const getUserDetails = useCallback(
    (userId) => {
      if (!userId) return Promise.resolve();
      dispatch(actions.fetchUserDetails(userId));
    },
    [dispatch]
  );

  const getUserDomains = useCallback(
    (userId) => {
      if (!userId) return Promise.resolve();
      dispatch(actions.fetchUserDomains(userId));
    },
    [dispatch]
  );

  const getUserSubDomains = useCallback(
    (userId) => {
      if (!userId) return Promise.resolve();
      dispatch(actions.fetchUserSubDomains(userId));
    },
    [dispatch]
  );

  const setUserDetails = useCallback(
    (details = {}) => {
      dispatch(actions.setUserDetails(details));
    },
    [dispatch]
  );

  const setUserDomains = useCallback(
    (domains = []) => {
      dispatch(actions.setUserDomains(domains));
    },
    [dispatch]
  );

  const setUserSubDomains = useCallback(
    (subDomains = []) => {
      dispatch(actions.setUserSubDomains(subDomains));
    },
    [dispatch]
  );

  return {
    // State
    user,
    isAuth,
    userDetails,
    userDomains,
    userSubDomains,
    isLoggedInByMagicLink: user?.isAdmin ?? false,

    // Actions
    setUser,
    setAuth,
    resetUser,
    getUserDetails,
    getUserDomains,
    getUserSubDomains,
    setUserDetails,
    setUserDomains,
    setUserSubDomains,
  };
};
